<template>
  <div v-if="!authorized" class="AuthLogin">
    <form name="login" class="AuthLogin__form pa-5" @submit.prevent="onSubmit">
      <BTextField
        v-model="form.username"
        :disabled="isLoading"
        label="Username"
        class="mb-3"
      />
      <BTextFieldPassword
        v-model="form.password"
        :disabled="isLoading"
        label="Password"
        class="mb-5"
      />

      <v-btn
        :loading="isLoading"
        :disabled="isLoading"
        depressed
        block
        type="submit"
        v-text="'Войти'"
      />
    </form>
  </div>
</template>

<script>
import { authStoreMapper } from './store'

import BTextField from '@/components/forms/BTextField.vue'
import BTextFieldPassword from '@/components/forms/BTextFieldPassword.vue'
import { getHash } from '@/views/Auth/utils'
import { StorageService } from '@/helpers/storage.service'


const createDefaultData = () => ({
  username: '',
  password: '',
})

export default {
  name: 'AuthLogin',
  components: {
    BTextField,
    BTextFieldPassword,
  },
  data: () => ({
    form: createDefaultData(),
    isLoading: false,
  }),
  computed: {
    ...authStoreMapper.mapGetters(['authorized', 'profile']),
  },
  methods: {
    ...authStoreMapper.mapActions(['getProfile', 'loginUser']),
    ...authStoreMapper.mapMutations(['setAuthorized']),

    async onSubmit() {
      try {
        this.isLoading = true
        await this.loginUser(this.form)
        await this.getProfile()
        await this.setAuthorized(true)
        this.saveMarkToLocalStorage()
        window.location.reload()
        // this.$router.replace('/')
        //   // eslint-disable-next-line no-console
        //   .catch((error) => console.info('[App warn]:', error.message))
      } catch (e) {
        console.dir(e)

        this.isLoading = false
        this.$notice.errors(e)
      }
    },
    saveMarkToLocalStorage() {
      const { username } = this.profile
      if (!username) return
      const hash = getHash(username)
      const hashKey = 'last-user-hash'
      const lastUserHash = StorageService.profile.get(hashKey)
      if (lastUserHash && lastUserHash !== hash) {
        StorageService.formDataDraft.clear()
      }
      StorageService.profile.set(hash, hashKey)
    },
  },
}
</script>

<style lang="scss">
.AuthLogin {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &__form {
    min-width: 400px;
    border: 1px solid $color-gray;
  }
}
</style>
